/* eslint-disable no-console */

/**
 * Simple logger utility functions
 */

export const logInfo = (message: string, data?: any) => {
  console.info(message, data);
};

export const logWarn = (message: string, data?: any) => {
  console.warn(message, data);
};

export const logError = (message: string, error?: any) => {
  console.error(message, error);
};

export const logDebug = (message: string, data?: any) => {
  console.debug(message, data);
};
